module.exports = __webpack_public_path__ + "img/elementary-school-course-title.af6b2342.svg";